<template>
  <v-container>
    <div class="home mt-3">
      Featured products:
      <v-carousel
        class="mb-3"
        cycle
        height="300"
        width=""
        hide-delimiter-background
        show-arrows-on-hover
      >
      <v-carousel-item
        v-for="(item, i) in notifications"
        :key="i"       
        reverse-transition="fade-transition"
        transition="fade-transition"
      > 
      <!-- :src="item.src" -->
      <!-- Using v-img to control image properties -->
      <v-img
        :src="item.src"
        height="100%"
        width="100%"
        contain
      ></v-img>
      <!-- <div
        class="fill-height fill-width"
        :style="{ backgroundImage: 'url(' + item.src + ')', backgroundSize: 'contain', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }"
      ></div> -->
      <div class="text-center mt-15 ">
        <v-btn v-if ="item.title"
        class="text-center ma-15"        
        color="primary"        
        @click="thisNotification(item)"
        >
         Read More
        </v-btn>
        <v-btn v-if ="item.innerroute"
        class="text-center ma-15"        
        color="primary"        
        @click="gotopage(item.innerroute)"
        >
         Goto 
        </v-btn>
       
      </div>
        
        </v-carousel-item>
      </v-carousel>
      <Notification/>
      Today's focus:
      <v-flex xs12 sm6 offset-sm3>
        <v-card
          class="d-flex pa-2 mb-3"
          color="#26c6da"
          dark
          max-width=""
          width="100%"
          justify="center"
          v-for="card_item in card_data"
          :key="card_item.name"
        >
          <div class="d-inline-flex pa-2">{{ card_item.desc }}</div>
        </v-card>
      </v-flex>
    </div>
  </v-container>
</template>

<script>
import Notification from "@/components/Notification";

export default {
  name: "Home",
  components: {
    Notification,
  },
  data() {
    return {    
      unsubscribeFromNotifications: null,
      alert: false, 
      card_data: [
        {
          name: "Appointments",
          desc: "appointments today (0)",
          number: 8,
          icon: "",
        },
        { name: "BRVARs", 
          desc: "BRVARs pending (0)",
          number: 16, icon: "" },
        {
          name: "Blocked",
          desc: "blocked customers (0)",
          number: 55,
          icon: "",
        },
        {
          name: "Lead",
          desc: "New Lead",
          number: 55,
          icon: "",
        },
        // {
        //   name: "Notification",
        //   desc: "Notifications",
        //   number: 55,
        //   icon: "",
        // },
      ],
    };
  },
  computed: {
    usersperson() {
      if (this.$store.getters.factsuser?.USER_DEFAULT_SMAN_DOCNO) {
        return this.$store.getters.factsuser?.USER_DEFAULT_SMAN_DOCNO;
      } else {
        return "";
      }
    },
    notifications(){
       return this.$store.getters.notifications
    }
  },
  methods: {
    thisNotification(item){
      this.$store.dispatch("thisNotification", item)
    },
    gotopage(route){
      this.$router.push(`${route}`);
    },
    // showthisNotification() {
    //   this.$emit("showthisNotification");
    // },
    // getToken(){
    //   this.$store.dispatch("getToken")
    // },
    // refreshToken(){
    //   this.$store.dispatch("refreshToken")
    // },
    // authchange(){
    //   this.$store.dispatch("refreshToken")
    // },
    // getAPI(){
    //   let resp = axios.get(this.$store.getters.sessionAPI + "authtest")
    //   console.log(resp)
    // },
    // postAPI(){
    //   let resp = axios.post(this.$store.getters.sessionAPI + "auth", {
    //    public_id: this.usersperson,       
    //   });
    //   console.log(resp)
    // },
    // getaxiosInstanceAPI(){
    //   let resp = axiosInstance.get(this.$store.getters.sessionAPI + "authtest")
    //   console.log(resp)
    // },
    // postaxiosInstanceAPI(){
    //   let resp = axiosInstance.post(this.$store.getters.sessionAPI + "auth", {
    //    public_id: this.usersperson
    //   });
    //   console.log(resp)
    // }
  },
  beforeDestroy() {
    if (this.unsubscribeFromNotifications) {
      this.unsubscribeFromNotifications();
    }
  },
  created() {
    
  },
  mounted() {
    // this.notifications;
    this.$store.dispatch("getSalesPersons", { smandocno: this.usersperson })
    // this.unsubscribeFromNotifications = this.$store.dispatch("getNotification")
    this.$store.dispatch("getNotification").then(unsubscribe => {
    this.unsubscribeFromNotifications = unsubscribe;
  });
  },
  // created(){
  //   this.$store.dispatch("getSalesPersons", { smandocno: this.usersperson })
  //   this.$store.dispatch("getNotification")
  // } 

};
</script>
